module.exports = __webpack_public_path__ + "img/slider-2.6260d7ce.jpeg";